import { Stack } from '@mui/material';
import { Subsidiary } from '@vy/types';
import { FC } from 'react';
import { useNetSuiteSubsidiaries } from '../../../../../../../hooks/requests/integrations/net-suite/use-netsuite-subsidiaries';
import { SyncErpSubsidiaryItem } from './SyncErpSubsidiaryItem';

type SyncErpSubsidiaryProps = {
  subsidiaries: Subsidiary[];
};

export const SyncErpSubsidiary: FC<SyncErpSubsidiaryProps> = ({ subsidiaries }) => {
  const { data } = useNetSuiteSubsidiaries();
  const nsSubsidiaries = data?.subsidiaries ?? [];

  return (
    <Stack
      spacing={3}
      sx={{
        paddingTop: "34px",
        paddingLeft: "18px",
        width: "700px"
      }}>
      {subsidiaries.map((vayuSubsidiary) => (
        <SyncErpSubsidiaryItem
          key={vayuSubsidiary.id}
          vayuSubsidiary={vayuSubsidiary}
          nsSubsidiaries={nsSubsidiaries}
          allSubsidiaries={subsidiaries}
        />
      ))}
    </Stack>
  );
};
